import React, { useState } from "react";
import Card from "@mui/material/Card";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import TextField from "@mui/material/TextField";
import BeatLoader from "react-spinners/BeatLoader";
import SuiTypography from "components/SuiTypography";
import LeadValidationProvider from "providers/LeadValidationProvider";

function LeadValidationCard() {
  const [idNumber, setIdNumber] = useState("");
  const [response, setResponse] = useState("");
  const [isResult, setIsResult] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const resetTextElements = () => {
    setIdNumber("");
    setResponse("");
    setPhoneNumber("");
    setIsResult(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await initiateValidation();
  };

  const initiateValidation = async () => {
    const res = await LeadValidationProvider.validateLead(idNumber,phoneNumber);
    if (res == "true") {
      setResponse('True');
      setIsLoading(false);
    }else if (res == "false") {
      setResponse('False');
      setIsLoading(false);
    }else{
      /*Will propose that we log these session into a table and somehow we notifie the agent to not 
      discade this lead as it will be re-check later after the network issue if fixed*/
      console.log('possible network error occured!')
    }
 }
  return (
    <Card sx={{ height: "100%" }}>
      <SuiBox p={3}>
        {isLoading ? (
          <SuiBox display="flex" flexDirection="column" alignItems="center" justifyContent="center" my={5}>
            <BeatLoader color="#1A73E8" size={15} />
            <SuiTypography variant="caption" mt={1}>
              Please wait...
            </SuiTypography>
          </SuiBox>
        ) : (
          <>
            <SuiBox display="flex" justifyContent="center" alignItems="center" mb={3}>
              <SuiTypography variant="h4" fontWeight="medium" textTransform="capitalize">
                Lead Validation
              </SuiTypography>
            </SuiBox>
            {response ==""?(
                <> 
                <SuiBox display="flex" alignItems="center" gap={2} mb={4}>
                    <SuiTypography variant="button" fontWeight="regular" minWidth="120px" noWrap>
                    ID Number:
                    </SuiTypography>
                    <TextField
                    variant="outlined"
                    placeholder="Enter ID Number"
                    fullWidth
                    value={idNumber}
                    onChange={(e) =>
                        setIdNumber(e.target.value.replace(/[^0-9]/g, "").slice(0, 13),setResponse(""))
                    }
                    inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 13,
                    }}
                    />
                </SuiBox>
    
                <SuiBox display="flex" alignItems="center" gap={2} mb={4}>
                    <SuiTypography variant="button" fontWeight="regular" minWidth="120px" noWrap>
                    Phone Number:
                    </SuiTypography>
                    <TextField
                    variant="outlined"
                    placeholder="Enter Phone Number"
                    fullWidth
                    value={phoneNumber}
                    onChange={(e) =>
                        setPhoneNumber(e.target.value.replace(/[^0-9]/g, "").slice(0, 13),setResponse(""))
                    }
                    inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 13,
                    }}
                    />
                </SuiBox>
              </>
            ):(
                <>
                    <SuiBox display="flex" justifyContent="center" alignItems="center" mb={3}>
                        <SuiTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                            Results
                        </SuiTypography>
                    </SuiBox>
                    <SuiBox display="flex" justifyContent="center" alignItems="center" mb={3}>
                        <SuiTypography variant="h5" fontWeight="bold" textTransform="capitalize" color={response === "" || response === "False" ? "info" : "error"}>
                            Fraudulent : {response}
                        </SuiTypography>
                    </SuiBox>
                </>
            )}
            <SuiBox display="flex" justifyContent="space-between">
              <SuiButton variant="outlined" color="secondary" onClick={resetTextElements}>
                Cancel
              </SuiButton>
              <SuiButton variant="contained" color="info" onClick={handleSubmit}>
                Submit
              </SuiButton>
            </SuiBox>
          </>
        )
        }
      </SuiBox>
    </Card>
  );
}

export default LeadValidationCard;
